(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/oddset/kambi-offering/assets/javascripts/sockets2.js') >= 0) return;  svs.modules.push('/components/oddset/kambi-offering/assets/javascripts/sockets2.js');
"use strict";

var _svs$oddset, _svs$oddset2;

const logger = svs.core.log.getLogger('components:oddset:kambi-offering:sockets2');
const kambiPushApiUrl = (_svs$oddset = svs.oddset) === null || _svs$oddset === void 0 || (_svs$oddset = _svs$oddset.kambiOfferingApiUrl) === null || _svs$oddset === void 0 || (_svs$oddset = _svs$oddset.data) === null || _svs$oddset === void 0 ? void 0 : _svs$oddset.kambiPushApiUrl;
const kambiOfferingSocketChannelPrefix = (_svs$oddset2 = svs.oddset) === null || _svs$oddset2 === void 0 || (_svs$oddset2 = _svs$oddset2.kambiOfferingApiUrl) === null || _svs$oddset2 === void 0 || (_svs$oddset2 = _svs$oddset2.data) === null || _svs$oddset2 === void 0 ? void 0 : _svs$oddset2.kambiOfferingSocketChannelPrefix;
const normalizeSocketMessages = svs.components.oddset.kambiOffering.common.normalize.normalizeSocketMessages;
const localizedGeneralChannel = "".concat(kambiOfferingSocketChannelPrefix, ".sv.ev.json");
const nonLocalizedGeneralChannel = "".concat(kambiOfferingSocketChannelPrefix, ".ev.json");
let socketInstance = null;
const MAXIMUM_ATTEMPTS = 5;
const subscribers = new Set();
const onMessage = normalizedMessages => {
  normalizedMessages.forEach(normalizedMessage => {
    subscribers.forEach(subscriber => {
      var _normalizedMessage$pa;
      if (subscriber.eventId === ((_normalizedMessage$pa = normalizedMessage.payload) === null || _normalizedMessage$pa === void 0 ? void 0 : _normalizedMessage$pa.eventId)) {
        subscriber.onMessageCallback(normalizedMessage);
      }
    });
  });
};
const onError = error => {
  subscribers.forEach(subscriber => {
    subscriber.onSocketError(error);
  });
};
const initSocket = () => {
  socketInstance = window.io(kambiPushApiUrl, {
    transports: ['websocket'],
    upgrade: false,
    autoConnect: false,
    path: '/socket.io'
  });
  socketInstance.on('connect', () => {
    logger.debug('Socket connected');
  });
  socketInstance.on('disconnect', reason => {
    logger.info("Socket disconnected: ".concat(reason));
  });
  socketInstance.on('reconnect', attemptNumber => {
    logger.info("Socket reconnected after ".concat(attemptNumber, " attempts."));
  });
  socketInstance.on('error', error => {
    const errorMsg = "Socket error: ".concat(error);
    logger.warn(errorMsg);
    onError(errorMsg);
  });
  socketInstance.on('reconnect_attempt', attemptNumber => {
    logger.info("Socket reconnect attempt ".concat(attemptNumber));
    if (attemptNumber >= MAXIMUM_ATTEMPTS) {
      const errorMsg = "Closing socket after ".concat(attemptNumber, " reconnection attempts.");
      logger.error(errorMsg);
      onError(errorMsg);
      socketInstance.close();
    }
  });
  socketInstance.on('message', incomingMessage => {
    const messages = JSON.parse(incomingMessage);
    onMessage(normalizeSocketMessages(messages));
  });
};
const connectSocket = () => {
  socketInstance.connect();
  socketInstance.emit('subscribe', {
    topic: localizedGeneralChannel
  });
  socketInstance.emit('subscribe', {
    topic: nonLocalizedGeneralChannel
  });
};
const disconnectSocket = () => {
  socketInstance.emit('unsubscribe', {
    topic: localizedGeneralChannel
  });
  socketInstance.emit('unsubscribe', {
    topic: nonLocalizedGeneralChannel
  });
  socketInstance.disconnect();
};
const addSubscriber = newSubscriber => {
  if (socketInstance === null) {
    initSocket();
  }
  if (subscribers.size === 0) {
    connectSocket();
  }

  if (!subscribers.values().some(subscriber => subscriber.eventId === newSubscriber.eventId)) {
    const localizedEventChannel = "".concat(kambiOfferingSocketChannelPrefix, ".sv.ev.").concat(newSubscriber.eventId, ".json");
    const nonLocalizedEventChannel = "".concat(kambiOfferingSocketChannelPrefix, ".ev.").concat(newSubscriber.eventId, ".json");
    socketInstance.emit('subscribe', {
      topic: localizedEventChannel
    });
    socketInstance.emit('subscribe', {
      topic: nonLocalizedEventChannel
    });
  }
  subscribers.add(newSubscriber);
};
const deleteSubscriber = subscriber => {
  subscribers.delete(subscriber);

  if (!subscribers.values().some(existingSubscriber => existingSubscriber.eventId === subscriber.eventId)) {
    const localizedEventChannel = "".concat(kambiOfferingSocketChannelPrefix, ".sv.ev.").concat(subscriber.eventId, ".json");
    const nonLocalizedEventChannel = "".concat(kambiOfferingSocketChannelPrefix, ".ev.").concat(subscriber.eventId, ".json");
    socketInstance.emit('unsubscribe', {
      topic: localizedEventChannel
    });
    socketInstance.emit('unsubscribe', {
      topic: nonLocalizedEventChannel
    });
  }
  if (subscribers.size === 0) {
    disconnectSocket();
  }
};

const subscribe = function (eventId, onMessageCallback) {
  let onSocketError = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : () => {};
  if (!eventId) {
    throw new Error('eventId is required to subscribe to socket messages');
  }
  if (!onMessageCallback) {
    throw new Error('onMessageCallback function is required to subscribe to socket messages');
  }
  const subscriber = {
    eventId,
    onMessageCallback,
    onSocketError
  };
  addSubscriber(subscriber);
  return () => {
    deleteSubscriber(subscriber);
  };
};
setGlobal('svs.components.oddset.kambiOffering.setupSockets2', {
  subscribe
});

 })(window);